<template>
  <vs-col v-if="deliveryCondition" vs-w="12" class="row-container">
    <p>{{ title }}</p>
    <div class="divider" />
    <div class="row">
      <p class="price-value">
        {{ value > 0 ? (value).toString().numberFormat() : 'رایگان' }}
      </p>
      <p v-if="value > 0" class="tooman">
        ریال
      </p>
    </div>
  </vs-col>
</template>
<script>
export default {
  name: "InvoiceElement",
  computed: {
    deliveryCondition() {
      if (this.isDelivery) {
        return this.orderType === 'outdoor';
      }

      return true;
    }
  },
  props: {
    title: {
      required: true,
      type: String
    },
    value: {
      required: true,
      type: Number
    },
    orderType: {
      required: false,
    },
    isDelivery: {
      required: false,
    }
  },
};
</script>

<style scoped lang="scss">
.row-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 10px 20px;
}

.row {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.price-label {
  font-size: 0.9rem;
}

.divider {
  display: flex;
  flex: 1;
  border: 0;
  border-top: 2px solid #e5e7eb;
  margin: 0 10px;
  border-style: dashed;
}

.price-value {
  margin-right: 5px;
  font-size: 1.2rem;
}

.tooman {
  color: #6b7280;
  font-size: 0.8rem;
  margin-top: 2px;
}
</style>
